import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Rhino Mind',
    href: '#rhino-mind'
  }, {
    name: 'Community',
    href: '#community'
  }, {
    name: 'Socials',
    href: '#socials'
  }];
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-rhino-black/90 backdrop-blur-md py-4 shadow-lg shadow-rhino-gold/5' : 'bg-transparent py-6'}`} data-id="element-87">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-88">
        <a href="#home" className="flex items-center gap-3" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/k32AHgZ5QWqakPbqyEoYha/4bfafa20-dc71-4720-a5fb-1cff6c6dca54.png" alt="Rhino Strong Logo" className="h-14 md:h-16 w-auto brightness-200 invert" data-id="element-90" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-8" data-id="element-91">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-semibold tracking-wide text-gray-300 hover:text-rhino-gold transition-colors uppercase" data-id="element-92">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-gray-300 hover:text-rhino-gold" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-93">
          {mobileMenuOpen ? <X size={28} data-id="element-94" /> : <Menu size={28} data-id="element-95" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-rhino-charcoal border-t border-rhino-grey shadow-xl" data-id="element-96">
          <nav className="flex flex-col py-4" data-id="element-97">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="px-6 py-4 text-sm font-semibold tracking-wide text-gray-300 hover:text-rhino-gold hover:bg-rhino-grey transition-colors uppercase" data-id="element-98">
                {link.name}
              </a>)}
          </nav>
        </div>}
    </header>;
}